<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? `Add ${page}` : `Edit ${page}`}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? `Add ${page}`  : `Edit ${page}`}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-lg-8 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Page</h6>
            </div>
            <div v-if="showVideo === true">
              <ValidationObserver ref="currencyAddForm" id="roomTypeAddForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'name[' + language.code + ']'" class="form-label">Title:</label>
                      <input :id="'name[' + language.code + ']'" class="form-control" :name="'title_l[' + language.code + ']'" v-model="formData.title_l[language.code]" :class="checkValidation(classes, language.code)" placeholder="title" type="text">
                    </ValidationProvider>
                  </b-tab>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="continent_id" class="form-label">Hotel:</label>
                    <multiselect v-model="formData.hotel" placeholder="Select hotel" id="continent_id" :custom-label="customLabel" :class="classes"  :close-on-select="true" track-by="id" :options="hotels">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.title_l[$i18n.locale]}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.title_l[$i18n.locale]}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <ValidationProvider rules="required" tag="div" v-slot="{ classes }" class="form-group">
                    <label for="continent_id" class="form-label">Facilities:</label>
                    <multiselect v-model="formData.facilities" placeholder="Select facilities" :multiple="true" id="facilities_id" :custom-label="customLabel" :class="classes"  :close-on-select="true" track-by="id" :options="facilities">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.title_l[$i18n.locale]}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.title_l[$i18n.locale]}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <ImageUpload accept="image/png,image/jpeg,image/jpg" label="Image:"  name="image" uploadType="oneImage" type="image" :filesData="[formData.image]" />
                </b-tabs>
                <button class="btn ripple btn-main-primary mt-2" :disabled="buttonDisable" :class="buttonDisable ? 'button-readonly' : ''">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ImageUpload from '../../../components/ImageUpload'
const page = 'roomType'
const url = 'room-type'
export default {
  name: 'CityAdd',
  data () {
    return {
      page: page,
      url: url,
      showVideo: false,
      isEdit: false,
      buttonDisable: false,
      hotels: [],
      facilities: [],
      formData: {
        title_l: {}
      },
      isCreate: false,
      cookieId: ''
    }
  },
  components: {
    ImageUpload
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages,
      itemData: state => state[page].itemData
    })
  },
  created () {
    this.cookieId = this.$route.params.id
    if (this.cookieId === 'add') {
      this.isEdit = false
      this.isCreate = true
      this.showVideo = true
    } else {
      this.isEdit = true
      this.getData({ id: this.cookieId }).then(res => {
        this.showVideo = true
        this.formData = this.itemData
      })
    }
    this.getCreateData().then((res) => {
      this.hotels = res.hotels
      this.facilities = res.facilities
    })
  },
  methods: {
    ...mapActions({
      create: page + '/create',
      update: page + '/update',
      getCreateData: page + '/getCreateData',
      getData: page + '/getData'
    }),
    checkValidation (data) {
      return data
    },
    customLabel (data) {
      return `${data.title_l[this.$i18n.locale]}`
    },
    formSubmit () {
      this.$refs.currencyAddForm.validate().then(success => {
        if (success) {
          const form = document.getElementById('roomTypeAddForm')
          const formData = new FormData(form)
          this.formData.facilities.map((item) => {
            formData.append('facilities[]', item.id)
          })
          formData.append('hotel_id', this.formData.hotel.id)
          this.buttonDisable = true
          if (this.isCreate === true) {
            this.create(formData).then(() => {
              this.$toasted.success(this.$t('messages.success.courseCreated')).goAway(1500)
              this.$router.push('/' + this.url)
            }).catch(() => {
              this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
            }).finally(() => {
              this.buttonDisable = false
            })
          } else {
            formData.append('_method', 'PUT')
            this.update({ data: formData, id: this.$route.params.id }).then(res => {
              this.$toasted.success(this.$t('messages.success.courseUpdated')).goAway(1500)
              this.$router.push('/' + this.url)
            }).catch(() => {
              this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
            }).finally(() => {
              this.buttonDisable = false
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
